<template>
    <div class="content flex-sub wrapper flex flex-direction">
        <div class="flex-sub bg-white radius padding-lr ">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form" labelWidth="auto">
                <el-form-item ref="title" label="议题" prop="title">
                    <el-input v-model="ruleForm.title" placeholder="请输入" :disabled="readonly">
                    </el-input>
                </el-form-item>
                <el-form-item ref="meeting_time" label="时间" prop="meeting_time">
                    <el-date-picker
                        v-model="ruleForm.meeting_time"
                        placeholder="选择日期"
                        type="date"
                        value-format="yyyy-MM-dd" :disabled="readonly">
                    </el-date-picker>
                </el-form-item>
                <el-form-item ref="address" label="地点" prop="address">
                    <el-input v-model="ruleForm.address" placeholder="请输入" :disabled="readonly">
                    </el-input>
                </el-form-item>
                <el-form-item ref="meeting_file" label="会议材料" prop="meeting_file">
                   <upload-file type="file" :files="ruleForm.meeting_file" multiple @uploadFile="uploadFile"></upload-file>
                </el-form-item>
                <el-form-item ref="content" label="会议通知" prop="content">
                   <ck-basic-editor class="bg-gray" :content="content" @watchEditor="watchEditor"></ck-basic-editor>
                </el-form-item>

            </el-form>
            <div class="flex align-center justify-end margin-top" v-if="!readonly">
                <el-button :loading="loading" class="btn min" type="primary" @click="submitForm('ruleForm')">发布
                </el-button>
            </div>
        </div>
        <el-button class="choose-model bg-white text-red" round @click="templateDialog = true"><i class="el-icon-s-operation"></i>推荐模版</el-button>
        <template-dialog :dialog-visible="templateDialog" :type="0" @watchState="watchState"></template-dialog>
    </div>
</template>

<script>

import {confirm, TOAST, toast} from "@/utils/utils";
import {addMeetingIssue, getMeetingDetail} from "@/api";
import UploadFile from "@/views/web/components/UploadFile";
import CkBasicEditor from "@/views/web/components/CKBasicEditor";
import TemplateDialog from "@/views/web/manager/page/standard/components/TemplateDialog";

export default {
    name: "MeetingIssue",
    components: {TemplateDialog, CkBasicEditor, UploadFile},
    data() {
        return {
            content:'',
            ruleForm: {
                title: '',
                meeting_time: '',
                address: '',
                meeting_file: [],
                content: '',
            },
            rules: {
                title: [
                    {required: true, message: '请输入议题', trigger: 'change'},
                ],
                meeting_time: [
                    {required: true, message: '请选择时间', trigger: 'change'},
                ],
                address: [
                    {required: true, message: '请输入地点', trigger: 'change'},
                ],
                content: [
                    {required: true, message: '请输入会议通知', trigger: 'change'},
                ],
            },
            loading: false,
            readonly:false,
            templateDialog:false
        }
    },
    props: {
        type: {//1党员大会 2 委员会
            type: Number,
            default: 1
        },
        aid: {
            type: Number,
            default: 0
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        if (this.aid) this.init()
    },
    methods: {
        async init() {
            let _data = await getMeetingDetail(this.aid)
            this.ruleForm.title = _data.data.title
            this.ruleForm.meeting_time = _data.data.meeting_time
            this.ruleForm.address = _data.data.address
            this.ruleForm.meeting_file = _data.data.meeting_file
            this.ruleForm.content = _data.data.content
            this.content = _data.data.content
        },
        uploadFile(data){
            if (data) {
                this.ruleForm.meeting_file = data.files
            }
        },
        watchEditor(data) {
            this.ruleForm.content = data
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addItem();
                }
            });
        },
        async addItem() {
            this.loading = true
            let _data = await addMeetingIssue(this.type,this.aid,this.ruleForm.title,this.ruleForm.meeting_time,this.ruleForm.address,
                    JSON.stringify(this.ruleForm.meeting_file),this.ruleForm.content)
            this.loading = false
            if (_data.status === 200) {
                // toast('保存成功', TOAST.success)
                confirm(`保存成功`, `是否进行下一步信息填写？`, () => {
                    this.$emit('watchNext', _data.data.id,true)
                }, '确认', true,()=>{
                    this.$emit('watchNext', _data.data.id,false)
                })

            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        watchState(data) {
            if (data) {
                this.content = data.content
            }
            this.templateDialog = false;
        }
    },
    filters: {

    },
    watch: {
        aid() {
            if (this.aid) {
                this.init();
            } else {
                this.content = ''
                this.$refs.ruleForm.resetFields()
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    position: relative;
    .choose-model {
        position: absolute;
        bottom: 200px;
        right: 30px;
    }
}
</style>